import { ScopeBag, ScopeHierarchyNode, ScopeItem } from "Shared/Components/Scope/Scopes.types";
import { AllHierarchies } from "../Hierarchy";
import { getDefaultValueScopeType } from "../Hierarchy/SubstrateScopeNodeDefaults";

/**
 * Extract and sort the provided scope bag in the order of the scope hierarchy.
 * @param cloudServiceEnvironment Current cloud environment
 * @param bag Scope bag to be sorted
 * @returns Sorted scope bag
 */
export const extractSortedScopesFromBag = (cloudServiceEnvironment: string, bag?: ScopeBag) => {
    if (!bag || !bag.ScopeHierarchyId) {
        return bag;
    }

    const hierarchy = AllHierarchies.filter((h) => bag.ScopeHierarchyId.includes(h.HierarchyId));
    if (hierarchy.length && hierarchy[0]) {
        const currentHierarchy = hierarchy[0];
        let hierarchyCurrentNodes: ScopeHierarchyNode[] | undefined =
            currentHierarchy.Root.ScopeType.toLowerCase() === "global" ? currentHierarchy.Root.ChildScopes : [currentHierarchy.Root];

        const sortedScopeItems: ScopeItem[] = [];
        while (hierarchyCurrentNodes && hierarchyCurrentNodes.length) {
            // hierarchyCurrentNodes may have multiple nodes e.g. CAFE has [faultZoneScope, forestScope], try to match each of node with bag's current scope
            // and drill down to the next level of that child scope branch
            for (const currentHierarchyNode of hierarchyCurrentNodes) {
                let currentScopeItem: ScopeItem | undefined;
                bag.Scopes?.forEach((s) => {
                    if (currentHierarchyNode.ScopeType.toLowerCase() === s.ScopeType?.toLowerCase()) {
                        currentScopeItem = {
                            ...s,
                            ScopeType: currentHierarchyNode.ScopeType,
                            DisplayName: currentHierarchyNode.DisplayName,
                            Value:
                                s.Value || getDefaultValueScopeType(currentHierarchyNode.ScopeType, cloudServiceEnvironment, currentHierarchyNode.DefaultValue)
                        };
                    }
                });

                if (!currentScopeItem && currentHierarchyNode.ScopeType.toLowerCase() === "ring") {
                    // We need to add the ring scope type to the bag if it is not present
                    currentScopeItem = {
                        ScopeType: currentHierarchyNode.ScopeType,
                        DisplayName: currentHierarchyNode.DisplayName,
                        Value: getDefaultValueScopeType(currentHierarchyNode.ScopeType, cloudServiceEnvironment, currentHierarchyNode.DefaultValue)
                    };
                }
                if (currentScopeItem) {
                    sortedScopeItems.push(currentScopeItem);
                }

                hierarchyCurrentNodes = currentHierarchyNode.ChildScopes;
            }
        }

        bag.Scopes = sortedScopeItems;
        return bag;
    }
    // Could not find matching hierarchy, return the bag as is since hierarchy might be coming from MaaS hierarchy database
    return bag;
};
